/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Reply_Mark_Done_Aria_LabelInputs */

const en_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark reply as done`)
};

const fr_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer la reponse comme terminee`)
};

const de_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort als erledigt markieren`)
};

const it_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna la risposta come completata`)
};

const ru_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отметьте ответ как выполненный`)
};

const es_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar la respuesta como realizada`)
};

const zh_cn2_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记为已完成`)
};

const ja_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返信を完了としてマークする`)
};

const hi_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तर को पूर्ण के रूप में चिह्नित करें`)
};

const pt_pt2_notes_reply_mark_done_aria_label = /** @type {(inputs: Notes_Reply_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque a resposta como concluída.`)
};

/**
* | output |
* | --- |
* | "Mark reply as done" |
*
* @param {Notes_Reply_Mark_Done_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_reply_mark_done_aria_label = /** @type {((inputs?: Notes_Reply_Mark_Done_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Reply_Mark_Done_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notes_reply_mark_done_aria_label(inputs)
	if (locale === "de") return de_notes_reply_mark_done_aria_label(inputs)
	if (locale === "it") return it_notes_reply_mark_done_aria_label(inputs)
	if (locale === "ru") return ru_notes_reply_mark_done_aria_label(inputs)
	if (locale === "es") return es_notes_reply_mark_done_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_notes_reply_mark_done_aria_label(inputs)
	if (locale === "ja") return ja_notes_reply_mark_done_aria_label(inputs)
	if (locale === "hi") return hi_notes_reply_mark_done_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_notes_reply_mark_done_aria_label(inputs)
	return en_notes_reply_mark_done_aria_label(inputs)
});